import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function ExcelImportDialog({ open, onOpenChange, endpoint, columns, onDone }) {
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post(endpoint, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success(`Imported ${data.created} records`);
      onOpenChange(false);
      onDone && onDone();
    } catch (e) {
      toast.error(e.response?.data?.detail || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg bg-white" data-testid="excel-import-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Bulk import from Excel</DialogTitle>
        </DialogHeader>
        <div className="space-y-3 text-sm">
          <div className="border border-amber-200 bg-amber-50 p-3 rounded-[4px]">
            <div className="label-eyebrow !text-amber-800 mb-1">Required column headers</div>
            <div className="font-mono-rw text-xs text-amber-900">{columns.join(" • ")}</div>
            <div className="text-xs text-amber-800 mt-2">
              If any column is missing or misnamed the upload will fail with an error.
            </div>
          </div>
          <input
            type="file"
            accept=".xlsx,.xls"
            onChange={(e) => setFile(e.target.files?.[0] || null)}
            className="block w-full text-sm border border-[var(--rw-border)] rounded-[4px] p-2"
            data-testid="excel-file-input"
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            onClick={submit}
            disabled={!file || busy}
            className="bg-[var(--rw-sidebar)] hover:bg-[var(--rw-sidebar-hover)]"
            data-testid="excel-import-submit"
          >
            {busy ? "Uploading…" : "Upload"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
